import { render, staticRenderFns } from "./AreaTreePath.vue?vue&type=template&id=d1204334&scoped=true"
import script from "./AreaTreePath.vue?vue&type=script&lang=ts"
export * from "./AreaTreePath.vue?vue&type=script&lang=ts"
import style0 from "./AreaTreePath.vue?vue&type=style&index=0&id=d1204334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1204334",
  null
  
)

export default component.exports